const FontFaceObserver = require('fontfaceobserver');

addEventListener('DOMContentLoaded', () => {
    const fontA = new FontFaceObserver(
        'Open Sans Condensed',
        {
            weight: '700',
            style: 'normal',
        }
    );

    const fontB = new FontFaceObserver(
        'Open Sans',
        {
            weight: '400',
            style: 'normal',
        }
    );

    const fontsLoaded = Promise.all([
        fontA.load(null, 1000),
        fontB.load(null, 1000)
    ]);

    if (sessionStorage.fontsLoadedFoutWithClassPolyfill) {
        document.documentElement.className += " wf-active";
        return;
    }

    fontsLoaded.then(() => {
        document.documentElement.className += " wf-active";
        sessionStorage.fontsLoadedFoutWithClassPolyfill = true;
    }).catch(() => {
        document.documentElement.className += " wf-fallback";
        console.log("Font loading failed. Doing fallback.");
    });
});
